import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IParamsUpdateVoiceGreetingName,
  type IResponseGreetingUsage,
  type IResponseVoiceGreeting,
} from './types'

class Api {
  getVoiceGreetings(): Promise<AxiosResponse<IResponseVoiceGreeting[]>> {
    return baseApi.get('voice/greetings')
  }

  updateVoiceGreetingName(
    id: number,
    params: IParamsUpdateVoiceGreetingName
  ): Promise<AxiosResponse<IResponseVoiceGreeting>> {
    return baseApi.put(`voice/greetings/${id}`, params)
  }

  deleteVoiceGreeting(id: number): Promise<AxiosResponse<{ status: string }>> {
    return baseApi.delete(`voice/greetings/${id}`)
  }
  greetingUsage(id: number): Promise<AxiosResponse<IResponseGreetingUsage>> {
    return baseApi.get(`voice/greetings/${id}/usage`)
  }

  uploadVoiceGreeting(data: FormData): Promise<AxiosResponse<IResponseVoiceGreeting>> {
    return baseApi.post('voice/greetings', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}

export const GreetingsApi = new Api()
